import { ComputedRef, shallowRef } from 'vue'
import { documentAgreementRelatedSignatures } from '@/requests/documentAgreement'

export function useRelatedSignatures(documentAgreementId: ComputedRef<number>) {
  const relatedSignatures = shallowRef<any[]>([])

  const getRelatedSignatures = () => {
    return documentAgreementRelatedSignatures(documentAgreementId.value).then(
      res => {
        relatedSignatures.value = res
      }
    )
  }

  return { relatedSignatures, getRelatedSignatures }
}
